module.exports = __webpack_public_path__ + "static/media/calendar.8f188fa5.png";